<template>
  <div class="ThreeShader">
    <canvas id="canvas" ref="canvas" class="canvas" :class="{ show: ready }"/>  
  </div>
</template>

<script>

import Settings from '@/config/Settings'
import * as THREE from 'three'
import * as BAS from 'three-bas'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import OrbitControls from 'three-orbitcontrols'
import Animation from './Animation.js'
import gsap from "gsap"
import { Vertex, Fragment } from './shaders/ShaderThree.js'

export default {
  name: 'ThreeShader',
  props: ['indice'],
  data: ()=>({
    ready: true,
    is_loaded: false,
    exposure: 1,
  }),
  beforeDestroy() {
  
  },

  mounted() {

    this.$scene = new THREE.Scene()
    this.$clock = new THREE.Clock()

    this.$renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true })
    this.$renderer.setSize(window.innerWidth,window.innerHeight)
    this.$renderer.setPixelRatio( window.devicePixelRatio )

    this.$renderer.toneMapping = THREE.ACESFilmicToneMapping
    this.$renderer.toneMappingExposure =  Math.pow( this.exposure, 4.0 );
    this.$renderer.outputEncoding = THREE.sRGBEncoding

    this.$ambient = new THREE.AmbientLight( 0xffffff, 100, 100 )
    this.$scene.add( this.$ambient )

    this.$camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 0.1, 1000 )
    this.$camera.position.set(0, .5, .3)
    this.$camera.lookAt( 0, 0, 0 )

    this.$controls = new OrbitControls(this.$camera, this.$renderer.domElement)
    this.$controls.enableDamping = true
    this.$controls.dampingFactor = 0.25
    this.$controls.enableZoom = false

    this.$uniforms = { time: { value: 1.0 } }

    const geometry = new THREE.PlaneGeometry(2, 2)
    const material = new THREE.ShaderMaterial( {
      uniforms: this.$uniforms,
      vertexShader: Vertex,
      fragmentShader: Fragment,
    })



    const mesh = new THREE.Mesh( geometry, material )
    this.$scene.add( mesh )

    window.addEventListener( 'resize', this.onWindowResize )
    this.ready = true

    this.$nextTick(()=>{

      this.render()
    })

  },

  methods:{
    render(){ 

      this.$uniforms[ 'time' ].value = performance.now() / 1000
      this.$controls.update()
      this.$renderer.render(this.$scene, this.$camera)
      window.requestAnimationFrame(this.render) 
      
    },

    onWindowResize() {
      this.$camera.aspect = window.innerWidth / window.innerHeight
      this.$camera.updateProjectionMatrix()
      this.$renderer.setSize( window.innerWidth, window.innerHeight )
    },
  }

}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.ThreeShader
  position fixed
  top 0
  width 100vw
  height 100%
  overflow hidden  
 
  canvas
    width 100%
    height 100%
    opacity 0
    transition opacity .5s
    transition-delay 1

    &.show 
      opacity 1

  &__container
     width 100%
     position relative
     container-height(2)

</style>


